import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { validaSoloNumero, formatMoneda } from "../../../util/varios";
import "react-tabs/style/react-tabs.css";
import TablaDeudaInmueble from "./tablaDeudaInmueble";
import TablaHistoricosInmuebles from "./tablaHistoricoInmuebe";
import moment from "moment";
import TablaMultasInmuebles from "./tablaMultasInmuebles";
import TablaFacturasInmuebles from "./tablaFacturaInmuebles";
import axios from "axios";
import CatalogoValorFisCon from "../../../catalogos/catalogoValorFisConst";
import { Dimmer } from "../../spinner";
import { DangerButton, PrimaryButton, SuccessButton } from "../../../ui/buttons/Button";
import { Input, Checkbox } from "../../../ui/inputs/Input";

export const ContribuyenteInmueble = (props) => {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [valorConstruccion, setValorConstruccion] = useState(0);
  const [mostrar, setMostrar] = useState(false);
  const [mostrarValor, setMostrarValor] = useState(false);
  const [msg] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [contar1, setContar1] = useState(0);
  const [activate, setActivate] = useState(false);
  const txtCodigoCiu = useRef();
  const txtAlicuota = useRef();
  const txtRecargo = useRef();
  const txtMultas = useRef();
  const txtmontoanual = useRef();
  const txtInteres = useRef();
  const txtDescripcionActi = useRef();
  const txtAnios = useRef();
  const txtCodActividad = useRef();
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [factorCambio, setFactorCambio] = useState(0);

  const [idUsuario] = useState(localStorage.getItem("idusuario"));

  const [anioActu] = useState(localStorage.getItem("anioactu"));
  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const [declaWeb, setDeclaWeb] = useState();
  const txtIdComercio = useRef();
  const txtRitm = useRef();
  const txtNumPatente = useRef();

  const txtRitmT = useRef();

  const cmbdesde = useRef();
  const cmbhasta = useRef();
  const txtvaloruniconst = useRef();
  const txtmontoavaluo = useRef();
  const txtmontomensual = useRef();
  const [ip] = useState(localStorage.getItem("ip"));
  const [mac] = useState(localStorage.getItem("mc"));
  const [anio, setAnio] = useState([]);

  const [Avaluo, setAvaluo] = useState(0.0);
  const [Avaluo2, setAvaluo2] = useState(0.0);
  const [totalAvaluo, setTotalAvaluo] = useState(0.0);
  const [descuento, setDescuento] = useState(0.0);
  const [status, setStatus] = useState();
  const [montoAnual, setMontoAnual] = useState(0.0);
  const [montoMensual, setMontoMensual] = useState(0.0);
  const [disabled, setDisabled] = useState(false);
  const [periodo, setPeriodo] = useState();
  const [valorPorcentual, setValorPorcentual] = useState(1000.0);
  const txtannoDeuda = useRef();

  const radioExonerado1 = useRef();
  const radioExonerado2 = useRef();

  let montPagar;
  let valorPetro = props.factorCambio !== null ? props.factorCambio : 0.0;

  let terreno = 0.0;
  let construccion = 0.0;
  const blanquear = () => {
    setValorConstruccion("0.00");
    setVisible("hidden");
    setDescuento(0.0);
    setActivate(false);
  };
  const onCheckChange = () => {
    if (radioExonerado1.current.checked) {
      console.log("esta activo el si");
      setDisabled(true);
    } else if (radioExonerado2.current.checked && props.options !== 1) {
      console.log("esta activo el no");
      setDisabled(false);
    } else if (radioExonerado2.current.checked && props.options === 1) {
      console.log("esta activo el no");
      setDisabled(true);
    }
  };
  const onChange = (event) => {
    if (event.target.name === "idavaluo") {
      const selectedIndex = event.target.options.selectedIndex;
      let monto = event.target.options[selectedIndex].getAttribute("data-key");
      setAvaluo(parseFloat(monto));

      let porcentajeconstruc = valorConstruccion;
      let montoaval = monto;
      let uc = props.factorCambio;
      let ucaval = parseFloat(montoaval) * parseFloat(uc);
      let porce = parseFloat(porcentajeconstruc) / 100;
      let totalAnual = parseFloat(ucaval) * parseFloat(porce);
      let totalMes = totalAnual / 4;
      txtmontoanual.current.value = formatMoneda(
        totalAnual.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      txtmontomensual.current.value = formatMoneda(
        totalMes.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
  };
  const crearDeuda = (event) => {
    let sigue = true;
    if (txtannoDeuda.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "No se puede Cargar la Deuda Seleccione un año",
        icono: "informacion",
      });

      txtannoDeuda.current.focus();
      sigue = false;
    } else if (cmbdesde.current.value === "" || cmbhasta.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "La Fecha de Inicio y Final no pueden estar vacia",
        icono: "informacion",
      });

      sigue = false;
      cmbdesde.current.focus();
    } else if (cmbdesde.current.value > cmbhasta.current.value) {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "La Fecha de Inicio no puede ser Mayor a la Fecha Final",
        icono: "informacion",
      });

      sigue = false;
    } else if (sigue) {
      selectCargarDeuda();
    }
  };
  const calcularAV = () => {
    let porcentaje = 0.0;
    let procedentdepre = 0.0;
    let valoraval = 0.0;
    let valorTotal = 0.0;

    procedentdepre = parseFloat(descuento);
    valoraval = parseFloat(Avaluo);

    porcentaje =
      (parseFloat(valoraval) / valorPorcentual) * parseFloat(procedentdepre);

    valorTotal = parseFloat(valoraval) - parseFloat(porcentaje);

    setTotalAvaluo(valorTotal);

    if (radioExonerado1.current.checked) {
      setMontoAnual(0.0);
      setMontoMensual(0.0);
    } else if (radioExonerado2.current.checked) {
    }
  };
  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputCodigo") {
        txtCodActividad.current.focus();
      } else if (event.target.id === "inputCodigoActi") {
        txtCodigoCiu.current.focus();
      } else if (event.target.id === "inputCodigoCiu") {
        txtAnios.current.focus();
      } else if (event.target.id === "inputAnio") {
        txtDescripcionActi.current.focus();
      } else if (event.target.id === "inputDescripcion") {
        txtAlicuota.current.focus();
      } else if (event.target.id === "inputActualizada") {
        btnAcepta.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      return false;
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "inputAnio") {
          txtDescripcionActi.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const selectCargarDeuda = () => {
    let monto = txtmontomensual.current.value
      .replace(/\./g, "")
      .replace(/\./g, "")
      .replace(",", ".");
    let monto2 = monto / props.factorCambio;
    let endpoint = `${op.conexion}/api/inmueble/creardeudainmueble`;
    let body;
    body = {
      txtcodigo: parseInt(
        props.inmueble
          ? props.inmueble.idinmueble !== null
            ? props.inmueble.idinmueble.trim()
            : ""
          : ""
      ),
      cmbdesde: parseInt(cmbdesde.current.value),
      cmbhasta: parseInt(cmbhasta.current.value),
      txtvaloruniconst: valorConstruccion ? parseFloat(valorConstruccion) : 1,
      txtvalorporce: parseFloat(
        props.configInmueble.valorporcentual === 1 ? 100.0 : 1000.0
      ),
      txtmontoavaluo: parseFloat(
        txtmontoavaluo.current.value.replace(/\./g, "").replace(",", ".")
      ),
      txtmontomensual: monto2,
      txtvalorpetro: parseFloat(valorPetro),
      txtperiodo: parseInt(props.prd),
      txtnumpago: parseInt(props.np),

      txtidusua: JSON.parse(idUsuario),

      txtanioact: parseInt(anioActu),
      txtfechasis: fechaSistema,
      txtip: JSON.parse(ip),
      txtmac: JSON.parse(mac),
    };
    console.log(body);
  
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setActivate(false);
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Deuda Cargada",
            icono: "exito",
          });
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

    props.onHideCancela();
    blanquear();
  };

  const salir = () => {
    props.onHideCancela();
    blanquear();
  };

  useEffect(() => {
    let anioact = JSON.parse(localStorage.getItem("anioactu"));
    var nanio = [];
    var aini = parseInt(anioact) - 7;
    var afin = parseInt(anioact);

    for (let i = 0; i + aini <= afin; i++) {
      nanio.push({ anio: afin - i });
    }
    setAnio(nanio);
  }, []);

  const actualizarPermiso = () => {
    let endpoint = `${op.conexion}/api/inmueble/permisosactu`;

    let body;

    body = {
      recargo: txtRecargo.current.checked,
      multas: txtMultas.current.checked,
      interes: txtInteres.current.checked,

      ritm: txtRitmT.current.value !== "" ? txtRitmT.current.value : 0,
      id: props.inmueble ? props.inmueble.idinmueble : "",
    };

    console.log(body);

    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setActivate(false);

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Inmueble Actualizado.",
            icono: "exito",
          });
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const onChangeValidar = () => {
    let sigue = true;
    if (sigue) {
      actualizarPermiso();
    }
  };

  const updateValor = (values) => {
    setMostrarValor(false);
    txtIdComercio.current.value = values.idvalorfiscconstruc;
    txtNumPatente.current.value = values.descripcion;
    let montoaval = txtRitm.current.value
      .replace(/\./g, "")
      .replace(/\./g, "")
      .replace(",", ".");
    let uc = props.factorCambio;
    let ucaval = parseFloat(montoaval) * parseFloat(uc);
    let porce = parseFloat(values.porcentajeconstruc) / 100;
    let totalAnual = parseFloat(ucaval) * parseFloat(porce);
    let totalMes = totalAnual / 4;
    setValorConstruccion(values.porcentajeconstruc);
    txtmontoanual.current.value = formatMoneda(
      totalAnual.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtmontomensual.current.value = formatMoneda(
      totalMes.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );

    let porcentaje = 0.0;
    let procedentdepre = 0.0;
    let valoraval = 0.0;
    let valorTotal = 0.0;

    procedentdepre = parseFloat(descuento);
    valoraval = parseFloat(Avaluo);

    porcentaje =
      (parseFloat(valoraval) / valorPorcentual) * parseFloat(procedentdepre);

    valorTotal = parseFloat(valoraval) - parseFloat(porcentaje);

    setTotalAvaluo(valorTotal);

    if (radioExonerado1.current.checked) {
      setMontoAnual(0.0);
      setMontoMensual(0.0);
    } else if (radioExonerado2.current.checked) {
      let porcen = 0.0;
      let porcen2 = 0.0;
      let montMes = 0.0;

      porcen = parseFloat(values.porcentajeconstruc * valorPetro);
      porcen2 = porcen / valorPorcentual;
      montPagar = porcen2 * valorTotal;
      montMes = montPagar / props.np;
    }
  };

  const onKeyUpInm = (idinmueble) => {
    let campos = "*";
    let nomtab = "valorfiscconstruc";
    let nomid = "idvalorfiscconstruc";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtIdComercio.current.value = response.data.idvalorfiscconstruc;
            txtNumPatente.current.value = response.data.descripcion;
            setActivate(false);
            let porcentaje = 0.0;
            let procedentdepre = 0.0;
            let valoraval = 0.0;
            let valorTotal = 0.0;
            procedentdepre = parseFloat(descuento);
            valoraval = parseFloat(Avaluo);
            porcentaje =
              (parseFloat(valoraval) / valorPorcentual) *
              parseFloat(procedentdepre);
            valorTotal = parseFloat(valoraval) - parseFloat(porcentaje);
            setTotalAvaluo(valorTotal);
            if (radioExonerado1.current.checked) {
              setMontoAnual(0.0);
              setMontoMensual(0.0);
            } else if (radioExonerado2.current.checked) {
              let porcen = 0.0;
              let porcen2 = 0.0;
              let montMes = 0.0;
              let montoaval = txtRitm.current.value
                .replace(/\./g, "")
                .replace(/\./g, "")
                .replace(",", ".");
              let uc = props.factorCambio;
              let ucaval = parseFloat(montoaval) * parseFloat(uc);
              let porce = parseFloat(response.data.porcentajeconstruc) / 100;
              let totalAnual = parseFloat(ucaval) * parseFloat(porce);
              let totalMes = totalAnual / 4;
              setValorConstruccion(response.data.porcentajeconstruc);
              txtmontoanual.current.value = formatMoneda(
                totalAnual.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              );
              txtmontomensual.current.value = formatMoneda(
                totalMes.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              );
            }
          } else {
            txtIdComercio.current.value = "";
            txtNumPatente.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Valor Fiscal no existe.",
              icono: "error",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarValor = (event) => {
    validaSoloNumero(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        onKeyUpInm(event.target.value);
      } else {
        txtIdComercio.current.value = "";
        txtNumPatente.current.value = "";
      }
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.options);
        setFactorCambio(props.factorCambio);
        console.log(props.options);
        if (props.options === 1) {
          setDeshabilitado(true);
        } else {
          txtRitmT.current.focus();
          setDeshabilitado(false);
        }
        setDeclaWeb(props.declaweb);
        setTabIndex(0);
        setContar1(0);
        terreno = props.inmueble
          ? props.inmueble.valorterreno !== null
            ? parseFloat(props.inmueble.valorterreno)
            : 0.0
          : 0.0;
        construccion = props.inmueble
          ? props.inmueble.valorconstruccion !== null
            ? parseFloat(props.inmueble.valorconstruccion)
            : 0.0
          : 0.0;
        setAvaluo(terreno + construccion);
        setAvaluo2(terreno + construccion);

        let des = (terreno + construccion / 100) * parseFloat(descuento);
        setTotalAvaluo(terreno + construccion - des);
        onCheckChange();
        console.log(" el des: " + descuento);

        setStatus(
          props.inmueble
            ? props.inmueble.status !== "61"
              ? "INACTIVO"
              : "ACTIVO"
            : ""
        );

        if (radioExonerado1.current.checked) {
          setMontoAnual(0.0);
          setMontoMensual(0.0);
        } else if (radioExonerado2.current.checked) {
          let porcen = 0.0;
          let porcen2 = 0.0;
          let montMes = 0.0;
          porcen = parseFloat(
            props.valorConstruccion.porcentajeconstruc * valorPetro
          );
          porcen2 = porcen / 100;
          montPagar = porcen2 * (terreno + construccion - des);
          setMontoAnual(montPagar);
          montMes = montPagar / props.np;
          setMontoMensual(montMes);
          console.log(props.np);
        }
        blanquear();
        setPeriodo(props.prd);
        if (props.configInmueble === "") {
          setValorPorcentual(1000.0);
        } else {
          setValorPorcentual(
            props.configInmueble.valorporcentual !== null
              ? props.configInmueble.valorporcentual === 1
                ? 100.0
                : 1000.0
              : 0.0
          );
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Consultar Contribuyente - Inmuebles Urbanos"
            : "Gestionar Contribuyente - Inmuebles Urbanos"}
        </h3>
        <a
          type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <div className="col-2 m-0 p-0">
          <Input label="Código:"
            disabled
            defaultValue={
              props.inmueble
                ? props.inmueble.idinmueble !== null
                  ? props.inmueble.idinmueble.trim()
                  : ""
                : ""
            }
          />
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Input label="Ficha Catastral N°:"
            disabled
            defaultValue={
              props.inmueble
                ? props.inmueble.numficha !== null
                  ? props.inmueble.numficha.trim()
                  : ""
                : ""
            }
          />
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Input label="Inscp. Catastral N°:"
            disabled
            defaultValue={
              props.inmueble
                ? props.inmueble.numinscripcion !== null
                  ? props.inmueble.numinscripcion.trim()
                  : ""
                : ""
            }
          />
        </div>
        <div className="col-2 m-0 p-0 pl-2">
          <Input label='RITM:'
            disabled={operacion === 1 ? true : false}
            ref={txtRitmT}
            defaultValue={
              props.inmueble
                ? props.inmueble.ritm !== null
                  ? props.inmueble.ritm.trim()
                  : ""
                : ""
            }
          />
        </div>
        <div className="col-2 m-0 p-0 pl-2">
          <Input label='Estatus:'
            disabled
            defaultValue={
              props.inmueble
                ? props.inmueble.status === "61"
                  ? "ACTIVO"
                  : "INACTIVO"
                : ""
            }
          />
        </div>
        <div className="col-12 m-0 mt-2 p-0 d-flex flex-wrap align-items-center justify-content-between">
          <div className="col-8 m-0 p-2 d-flex border rounded">
            <div
              className="col-md-3 my-auto py-2 rounded text-center"
              style={{ backgroundColor: "#e9ecef" }}
            >
              <h5>
                <strong
                  style={{
                    color: "#000",
                  }}
                >
                  Código Catastral:
                </strong>
              </h5>
            </div>
            <table
              className="col"
              style={{
                fontSize: "13px",
                color: "#000",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{ padding: "4px", margin: 0 }}
                    className="text-center"
                    scope="col"
                  >
                    Edo.
                  </th>
                  <th
                    style={{ padding: "4px", margin: 0 }}
                    className="text-center"
                    scope="col"
                  >
                    Mun.
                  </th>
                  <th
                    style={{ padding: "4px", margin: 0 }}
                    className="text-center"
                    scope="col"
                  >
                    Parr.
                  </th>
                  <th
                    style={{ padding: "4px", margin: 0 }}
                    className="text-center"
                    scope="col"
                  >
                    Ambito
                  </th>
                  <th
                    style={{ padding: "4px", margin: 0 }}
                    className="text-center"
                    scope="col"
                  >
                    .
                  </th>
                  <th
                    style={{ padding: "4px", margin: 0 }}
                    className="text-center"
                    scope="col"
                  >
                    Sector.
                  </th>
                  <th
                    style={{ padding: "4px", margin: 0 }}
                    className="text-center"
                    scope="col"
                  >
                    Manz.
                  </th>
                  <th
                    style={{ padding: "4px", margin: 0 }}
                    className="text-center"
                    scope="col"
                  >
                    Parc.
                  </th>
                  <th
                    style={{ padding: "4px", margin: 0 }}
                    className="text-center"
                    scope="col"
                  >
                    SubP.
                  </th>
                  <th
                    style={{ padding: "4px", margin: 0 }}
                    className="text-center"
                    scope="col"
                  >
                    Nivel.
                  </th>
                  <th
                    style={{ padding: "4px", margin: 0 }}
                    className="text-center"
                    scope="col"
                  >
                    Unidad.
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{ fontSize: "14px", padding: 0, margin: 0 }}
                    className="text-center"
                  >
                    {props.inmueble
                      ? props.inmueble.codigocatastral !== null
                        ? props.inmueble.codigocatastral
                          .trim()
                          .substring(0, 2)
                        : ""
                      : ""}
                  </td>
                  <td
                    style={{ fontSize: "14px", padding: 0, margin: 0 }}
                    className="text-center"
                  >
                    {props.inmueble
                      ? props.inmueble.codigocatastral !== null
                        ? props.inmueble.codigocatastral
                          .trim()
                          .substring(2, 4)
                        : ""
                      : ""}
                  </td>
                  <td
                    style={{ fontSize: "14px", padding: 0, margin: 0 }}
                    className="text-center"
                  >
                    {props.inmueble
                      ? props.inmueble.codigocatastral !== null
                        ? props.inmueble.codigocatastral
                          .trim()
                          .substring(4, 6)
                        : ""
                      : ""}
                  </td>
                  <td
                    style={{ fontSize: "14px", padding: 0, margin: 0 }}
                    className="text-center"
                  >
                    {props.inmueble
                      ? props.inmueble.codigocatastral !== null
                        ? props.inmueble.codigocatastral
                          .trim()
                          .substring(6, 7)
                        : ""
                      : ""}
                  </td>
                  <td
                    style={{ fontSize: "14px", padding: 0, margin: 0 }}
                    className="text-center"
                  >
                    {props.inmueble
                      ? props.inmueble.codigocatastral !== null
                        ? props.inmueble.codigocatastral
                          .trim()
                          .substring(7, 9)
                        : ""
                      : ""}
                  </td>
                  <td
                    style={{ fontSize: "14px", padding: 0, margin: 0 }}
                    className="text-center"
                  >
                    {props.inmueble
                      ? props.inmueble.codigocatastral !== null
                        ? props.inmueble.codigocatastral
                          .trim()
                          .substring(9, 11)
                        : ""
                      : ""}
                  </td>
                  <td
                    style={{ fontSize: "14px", padding: 0, margin: 0 }}
                    className="text-center"
                  >
                    {props.inmueble
                      ? props.inmueble.codigocatastral !== null
                        ? props.inmueble.codigocatastral
                          .trim()
                          .substring(11, 14)
                        : ""
                      : ""}
                  </td>
                  <td
                    style={{ fontSize: "14px", padding: 0, margin: 0 }}
                    className="text-center"
                  >
                    {props.inmueble
                      ? props.inmueble.codigocatastral !== null
                        ? props.inmueble.codigocatastral
                          .trim()
                          .substring(14, 17)
                        : ""
                      : ""}
                  </td>
                  <td
                    style={{ fontSize: "14px", padding: 0, margin: 0 }}
                    className="text-center"
                  >
                    {props.inmueble
                      ? props.inmueble.codigocatastral !== null
                        ? props.inmueble.codigocatastral
                          .trim()
                          .substring(17, 20)
                        : ""
                      : ""}
                  </td>
                  <td
                    style={{ fontSize: "14px", padding: 0, margin: 0 }}
                    className="text-center"
                  >
                    {props.inmueble
                      ? props.inmueble.codigocatastral !== null
                        ? props.inmueble.codigocatastral
                          .trim()
                          .substring(20, 23)
                        : ""
                      : ""}
                  </td>
                  <td
                    style={{ fontSize: "14px", padding: 0, margin: 0 }}
                    className="text-center"
                  >
                    {props.inmueble
                      ? props.inmueble.codigocatastral !== null
                        ? props.inmueble.codigocatastral
                          .trim()
                          .substring(23, 26)
                        : ""
                      : ""}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-2 m-0 p-0">
            Valor Euro €:
            {formatMoneda(
              factorCambio.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            )}
          </div>
          <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap">
            <legend className="float-none w-auto m-0">
              Datos del Ocupante
            </legend>
            <div class="col-9 m-0 p-0">
              <Input label='Nombre y Apellido/Razón Social:'
                disabled
                defaultValue={
                  props.inmueble
                    ? props.inmueble.nombreocupante !== null
                      ? props.inmueble.nombreocupante.trim()
                      : ""
                    : ""
                }
              />
            </div>
            <div class="col-3 m-0 p-0 pl-2">
              <Input label='Cédula/Rif:'
                disabled
                defaultValue={
                  props.inmueble
                    ? props.inmueble.cedulaocupante !== null
                      ? props.inmueble.cedulaocupante.trim()
                      : ""
                    : ""
                }
              />
            </div>
            <div class="col-12 m-0 mt-2 p-0">
              <Input label='Dirección del Inmueble:'
                disabled
                defaultValue={
                  props.inmueble
                    ? "CIUDAD: " + props.inmueble &&
                      props.inmueble.parroquia !== null
                      ? props.inmueble.parroquia.trim()
                      : "" + props.inmueble &&
                        props.inmueble.dirinmue1 !== null
                        ? props.inmueble.dirinmue1.trim()
                        : "" + props.inmueble &&
                          props.inmueble.descridirinmue1 !== null
                          ? props.inmueble.descridirinmue1.trim()
                          : "" + props.inmueble &&
                            props.inmueble.dirinmue2 !== null
                            ? props.inmueble.dirinmue2.trim()
                            : "" + props.inmueble &&
                              props.inmueble.descridirinmue2 !== null
                              ? props.inmueble.descridirinmue2.trim()
                              : "" + props.inmueble &&
                                props.inmueble.descridirinmue3 !== null
                                ? props.inmueble.descridirinmue3.trim()
                                : "" + props.inmueble &&
                                  props.inmueble.dirinmue5 !== null
                                  ? props.inmueble.dirinmue5.trim()
                                  : "" + "N°: " + props.inmueble &&
                                    props.inmueble.numcivicoinmue !== null
                                    ? props.inmueble.numcivicoinmue.trim()
                                    : ""
                    : ""
                }
              />
            </div>
          </fieldset>

          <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap">
            <legend className="float-none w-auto m-0">
              Informacion del Inmueble
            </legend>
            <div class="col-3 m-0 mb-2 p-0">
              <Input label='Tenecia del Terreno:'
                disabled
                defaultValue={
                  props.inmueble
                    ? props.inmueble.tenenciaterreno !== null
                      ? props.inmueble.tenenciaterreno.trim()
                      : ""
                    : ""
                }
              />
            </div>
            <div class="col-3 m-0 mb-2 p-0 pl-2">
              <Input label='Tipo de Terreno:'
                disabled
                defaultValue={
                  props.inmueble
                    ? props.inmueble.regpropieterreno !== null
                      ? props.inmueble.regpropieterreno.trim()
                      : ""
                    : ""
                }
              />
            </div>
            <div class="col-3 m-0 mb-2 p-0 pl-2">
              <Input label='Area Total Construcción:'
                disabled
                defaultValue={
                  props.inmueble
                    ? props.inmueble.areaconstruccion !== null
                      ? props.inmueble.areaconstruccion.trim() + " Mts2"
                      : ""
                    : ""
                }
              />
            </div>
            <div class="col-3 m-0 mb-2 p-0 pl-2">
              <Input label='Tipo de Construcción:'
                disabled
                defaultValue={
                  props.inmueble
                    ? props.inmueble.tipoconstruccion !== null
                      ? props.inmueble.tipoconstruccion.trim()
                      : ""
                    : ""
                }
              />
            </div>
            <div class="col-3 m-0 p-0">
              <Input label='Fecha del Ultimo Avalúo:'
                type="date"
                disabled
                defaultValue={
                  props.inmueble
                    ? moment.utc(props.inmueble.fechaavaluo).format(
                      "YYYY-MM-DD"
                    ) !== null
                      ? moment.utc(props.inmueble.fechaavaluo).format(
                        "YYYY-MM-DD"
                      )
                      : ""
                    : ""
                }
              />
            </div>
            <div class="col-3 m-0 p-0 pl-2">
              <Input label='Uso del Inmueble:'
                disabled
                defaultValue={
                  props.inmueble
                    ? props.inmueble.usoconstruccion !== null
                      ? props.inmueble.usoconstruccion.trim()
                      : ""
                    : ""
                }
              />
            </div>
            <div class="col-3 m-0 p-0 pl-2">
              <Input label='Area Total del Terreno:'
                disabled
                defaultValue={
                  props.inmueble
                    ? props.inmueble.areaterreno !== null
                      ? props.inmueble.areaterreno.trim() + " Mts2"
                      : ""
                    : ""
                }
              />
            </div>
            <div class="col-3 m-0 p-0 pl-2">
              <Input label='Monto Total del Avalúo:'
                disabled
                defaultValue={
                  formatMoneda(
                    Avaluo.toString().replace(".", ","),
                    ",",
                    ".",
                    2
                  ) + " Bs."
                }
              />
            </div>
          </fieldset>

          <div className="col-6 m-0 my-2 p-2 d-flex aling-items-center gap-2 border-azul rounded">
            <h5 className="col-auto m-0 p-0 fw-bold">
              Exonerar:
            </h5>
            <div className="col m-0 p-0">
              <Checkbox label='Recargo'
                ref={txtRecargo}
                id="Recargo"
                disabled={props.options === 1 ? true : false}
                defaultChecked={
                  props.inmueble
                    ? props.inmueble.exonrecargos
                      ? true
                      : false
                    : false
                }
              />
            </div>
            <div className="col m-0 p-0">
              <Checkbox label='Multa'
                ref={txtMultas}
                id="Multa"
                disabled={props.options === 1 ? true : false}
                defaultChecked={
                  props.inmueble
                    ? props.inmueble.exonmultas
                      ? true
                      : false
                    : false
                }
              />
            </div>
            <div className="col m-0 p-0">
              <Checkbox label='Intereses'
                ref={txtInteres}
                disabled={props.options === 1 ? true : false}
                defaultChecked={
                  props.inmueble
                    ? props.inmueble.exonintereses
                      ? true
                      : false
                    : false
                }
                id="Intereses"
              />
            </div>
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <ul className="nav mb-2 d-flex gap-2" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link active bg-blue-100 text-light"
                id="datosTributarios"
                data-bs-toggle="tab"
                data-bs-target="#tributarios"
                type="button"
                role="tab"
                aria-controls="tributarios"
                aria-selected="true"
              >
                Datos Tributarios
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-200 text-light"
                id="deuda-tab"
                data-bs-toggle="tab"
                data-bs-target="#deuda"
                type="button"
                role="tab"
                aria-controls="deuda"
                aria-selected="false"
              >
                Deudas del Contribuyente
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-300 text-light"
                id="hist-tab"
                data-bs-toggle="tab"
                data-bs-target="#historico"
                type="button"
                role="tab"
                aria-controls="historico"
                aria-selected="false"
              >
                Historicos de Pagos
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-400 text-light"
                id="multas-tab"
                data-bs-toggle="tab"
                data-bs-target="#multas"
                type="button"
                role="tab"
                aria-controls="multas"
                aria-selected="false"
              >
                Multas
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-500 text-light"
                id="relacion-tab"
                data-bs-toggle="tab"
                data-bs-target="#relacion"
                type="button"
                role="tab"
                aria-controls="relacion"
                aria-selected="false"
              >
                Relacion de Facturas Contribuyente
              </a>
            </li>
          </ul>
          <div
            className="tab-content border-azul rounded p-0 m-0"
            id="myTabContent"
          >
            <div
              className="tab-pane fade show active p-0 m-0"
              id="tributarios"
              role="tabpanel"
              aria-labelledby="datosTributarios"
            >
              <div className="row col-md-12 mx-auto px-0">
                <div
                  className="row col-md-12 justify-content-between"
                  style={{ marginTop: "1%" }}
                >
                  <div className="col-md-3">
                    <h4>
                      <strong style={{ color: "#000" }}>
                        Datos Físcales
                      </strong>
                    </h4>
                  </div>
                  <div className="row col-md-3">
                    <div className="col-md-6 mx-auto">
                      <label className="">
                        <strong style={{ color: "#000" }}>Exonerado</strong>
                      </label>
                    </div>

                    <div className="col-md-3 justify-content-center form-check mx-auto">
                      <input
                        className="form-check-input text-center"
                        disabled
                        ref={radioExonerado1}
                        type="radio"
                        name="exonerado"
                        id="radio1"
                        value={
                          props.inmueble
                            ? props.inmueble.exonerado !== null
                              ? props.inmueble.exonerado
                              : 1
                            : 1
                        }
                        defaultChecked={
                          props.inmueble && props.inmueble.exonerado === 1
                        }
                        onChange={onCheckChange}
                      />

                      <label
                        className="form-check-label"
                        htmlFor="radioExonerado1"
                      >
                        Si
                      </label>
                    </div>
                    <div className="col-md-3 justify-content-center form-check mx-auto">
                      <input
                        className="form-check-input text-center"
                        disabled
                        ref={radioExonerado2}
                        type="radio"
                        name="exonerado"
                        id="radio2"
                        value={
                          props.inmueble
                            ? props.inmueble.exonerado !== null
                              ? props.inmueble.exonerado
                              : 0
                            : 0
                        }
                        defaultChecked={
                          props.inmueble && props.inmueble.exonerado === 0
                        }
                        onChange={onCheckChange}
                      />

                      <label
                        className="form-check-label"
                        htmlFor="radioExonerado2"
                      >
                        No
                      </label>
                    </div>
                  </div>
                </div>

                <div className="row  col-md-12 mx-auto px-0 ">
                  <div className="col-md-1 mb-1">
                    <label className="">
                      <strong style={{ color: "#000" }}>Avaluos: </strong>
                    </label>
                  </div>

                  <div className="input-group input-group-sm col-md-2 mb-1">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Año:
                    </span>
                    <select
                      name="idavaluo"
                      onChange={onChange}
                      ref={txtannoDeuda}
                      className="form-select form-select-sm top-0"
                      id="inputFechaReg"
                    >
                      <option value="">Seleccionar</option>
                      {props.avaluoC &&
                        props.avaluoC.map((item, index) => (
                          <option
                            key={index}
                            data-key={
                              parseFloat(item.valorconstruccion) +
                              parseFloat(item.valorterreno)
                            }
                            value={item.idavaluo}
                            onClick={calcularAV}
                          >
                            {" "}
                            {item.fechaavaluo.substring(0, 4)}{" "}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group input-group-sm col-md-3 mb-1">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      %Descuento:
                    </span>
                    <input
                      disabled
                      type="text"
                      style={{ textAlign: "right" }}
                      className="form-control form-control-sm"
                      id="inputProcedente"
                      defaultValue={0.0}
                      value={formatMoneda(
                        descuento.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      onChange={(event) => setDescuento(event.target.value)}
                      onKeyUp={calcularAV}
                      onBlur={calcularAV}
                    />
                  </div>

                  <div className="input-group input-group-sm col-md-3 mb-1">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Monto Avaluo:
                    </span>
                    <input
                      type="text"
                      disabled={true}
                      ref={txtmontoavaluo}
                      className="form-control form-control-sm text-right"
                      value={formatMoneda(
                        Avaluo.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      id="inputDenoComer"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group input-group-sm col-md-3 mb-1 pl-0">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Total Avaluo €:
                    </span>
                    <input
                      type="text"
                      disabled={true}
                      ref={txtmontoavaluo}
                      className="form-control form-control-sm text-right"
                      value={formatMoneda(
                        totalAvaluo.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      id="inputDenoComer"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group input-group-sm col-md-3 mb-1">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Id Valor Contruc-c.
                    </span>
                    <input
                      type="text"
                      ref={txtIdComercio}
                      disabled={operacion === 1 ? true : false}
                      className="form-control form-control-sm"
                      defaultValue={
                        props.idValor
                          ? props.idValor !== null
                            ? props.idValor.trim()
                            : ""
                          : ""
                      }
                      onKeyUp={validarValor}
                      onBlur={validarValor}
                      id="inputCodigo"
                    />
                    <button
                      disabled={operacion === 1 ? true : false}
                      onClick={() => {
                        setMostrarValor(true);
                      }}
                      className="btn btn-sm btn-info"
                    >
                      <i
                        disabled={deshabilitado}
                        className="fas fa-search"
                      ></i>
                    </button>
                  </div>

                  <div className="input-group input-group-sm col-md-6 mb-1">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Descripción:
                    </span>
                    <input
                      type="text"
                      ref={txtNumPatente}
                      disabled={true}
                      className="form-control form-control-sm col-md-12"
                      defaultValue={
                        props.valorConstruccion
                          ? props.valorConstruccion.descripcion !== null
                            ? props.valorConstruccion.descripcion.trim()
                            : ""
                          : ""
                      }
                      id="inputNumPatente"
                      onKeyUp={handleInputNumChange}
                      onBlur={handleInputNumChange}
                    />
                  </div>

                  <div className="input-group input-group-sm col-md-3 mb-1 pl-0">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Porcentaje de Cálculo %
                    </span>
                    <input
                      type="text"
                      disabled
                      ref={txtvaloruniconst}
                      className="form-control form-control-sm text-right"
                      value={
                        props.valorConstruccion &&
                          props.valorConstruccion.porcentajeconstruc
                          ? props.valorConstruccion.porcentajeconstruc
                          : formatMoneda(
                            valorConstruccion.toString().replace(".", ","),
                            ",",
                            ".",
                            2
                          )
                      }
                      onKeyUp={handleInputNumChange}
                      onBlur={handleInputNumChange}
                    />
                  </div>

                  <div className="input-group input-group-sm col-md-3 mb-1">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Monto del Avalú UC.
                    </span>
                    <input
                      type="text"
                      disabled={true}
                      ref={txtRitm}
                      className="form-control form-control-sm col-md-12 text-right"
                      value={formatMoneda(
                        totalAvaluo.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    />
                  </div>

                  <div className="input-group input-group-sm col-md-3 mb-1">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Desde el Año:
                    </span>
                    <select
                      ref={cmbdesde}
                      disabled={props.options === 1 ? true : false}
                      className="form-select"
                    >
                      {anio &&
                        anio.map((a) => (
                          <option key={a.anio} value={a.anio}>
                            {a.anio}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group input-group-sm col-md-3 mb-1">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Hasta el Año:
                    </span>
                    <select
                      disabled={props.options === 1 ? true : false}
                      ref={cmbhasta}
                      className="form-select"
                    >
                      {anio &&
                        anio.map((a) => (
                          <option key={a.anio} value={a.anio}>
                            {a.anio}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group input-group-sm col-md-3 mb-1 pl-0">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Total Anual Bs.
                    </span>
                    <input
                      type="text"
                      disabled
                      ref={txtmontoanual}
                      className="form-control form-control-sm  text-right bg-transparent"
                      /* value={formatMoneda(
                        montoAnual.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )} */
                      id="inputDenoComer"
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-9"></div>
                  <div className="input-group input-group-sm col-md-3 mb-1 pl-0">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Total Trimestral Bs.
                    </span>
                    <input
                      type="text"
                      ref={txtmontomensual}
                      className="form-control form-control-sm  text-right bg-transparent"
                      /* value={formatMoneda(
                        montoMensual.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )} */
                      id="inputDenoComer"
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="row col-md-12 justify-content-end mx-auto px-0 mb-1">
                  <div className="col-md-2">
                    <button
                      disabled={props.options === 1 ? true : false}
                      onClick={crearDeuda}
                      className="btn col-md-12 btn-primary"
                    >
                      <i className="">Cargar Deudas</i>{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="deuda"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              <div className="row col-md-12">
                <div className="col-md-12">
                  <TablaDeudaInmueble
                    tabDeuda={props.deuda}
                    idinmueble={props.inmueble && props.inmueble.idinmueble}
                    factorcambio={factorCambio}
                    credito={
                      props.credito && props.credito > 0 ? props.credito : 0.0
                    }
                  />
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="historico"
              role="tabpanel"
              aria-labelledby="hist-tab"
            >
              <TablaHistoricosInmuebles
                tabHis={props.historico}
                idinmueble={props.inmueble && props.inmueble.idinmueble}
              />
            </div>

            <div
              className="tab-pane fade"
              id="multas"
              role="tabpanel"
              aria-labelledby="multas-tab"
            >
              <TablaMultasInmuebles tabmulta={props.tabmulta} />
            </div>

            <div
              className="tab-pane fade"
              id="relacion"
              role="tabpanel"
              aria-labelledby="relacion-tab"
            >
              <TablaFacturasInmuebles facturaR={props.facturaR} />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <PrimaryButton
          icon='fa-edit m-0'
          disabled={props.options === 1 ? true : false}
          onClick={onChangeValidar}
        >
          Actualizar Avaluo
        </PrimaryButton>

        <SuccessButton
          disabled={props.options === 1 ? true : false}
          onClick={onChangeValidar}
        >
          Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={salir}
        >
          Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <Dimmer active={activate}></Dimmer>
      <CatalogoValorFisCon
        show={mostrarValor}
        onHideCancela={() => {
          setMostrarValor(false);
        }}
        onHideAcepta={updateValor}
      />
    </Modal>
  );
};
